import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AttachFileIcon = (props: IconProps) => (
  <Icon height="16px" width="15px" viewBox="0 0 16 15" {...props}>
    <path d="M11.523 10.313H4.335a2.5 2.5 0 1 1 0-5h7.813a1.563 1.563 0 0 1 0 3.125H5.585a.627.627 0 0 1-.625-.626c0-.343.281-.625.625-.625h5.938V6.25H5.585a1.563 1.563 0 0 0 0 3.125h6.563a2.5 2.5 0 1 0 0-5H4.335A3.436 3.436 0 0 0 .897 7.813c0 1.9 1.538 3.437 3.438 3.437h7.188v-.938Z" />
  </Icon>
);

export default memo(AttachFileIcon);
